import { Injectable } from '@angular/core';
import { AppState } from 'src/app/app.reducer';
import { EagerSelectEffects } from '../../select/eager-select/eager-select-effects';
import { deviceOptionActions } from './device-option.actions';
import { deviceOptionSelectors } from './device-option.reducer';

@Injectable({ providedIn: 'root' })
export class DeviceOptionEffects {
   defaultFields: string[] = ['deviceId', 'macAddress', 'deviceTypeId', 'accountId', 'phoneId', 'description'];

   defaultOrderingOptions: string[] = ['deviceTypeId:asc'];

   staticFilters: string[] = ['phoneId is null AND accountId = accountId'];

   load = this.eagerSelectEffects.createEagerSelectorLoadEffect(
      deviceOptionSelectors.selectState,
      'devices?SerializeEnumsAsStrings=true',
      this.defaultFields,
      this.defaultOrderingOptions,
      deviceOptionActions,
      this.staticFilters,
      true
   );

   constructor(private eagerSelectEffects: EagerSelectEffects<AppState>) {}
}
